// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  isSplit(nodes, index, pageHeight) {
    // 计算当前这块dom是否跨越了a4大小，以此分割
    if (nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight && nodes[index + 1] && nodes[index + 1]
      .offsetTop + nodes[index + 1].offsetHeight > pageHeight) {
      return true
    }
    return false
  },
  install(Vue, options) {
    const that = this
    Vue.prototype.getPdf = function() {
      // 当下载pdf时，若不在页面顶部会造成PDF样式不对,所以先回到页面顶部再下载
      let top = document.getElementById('print')
      if (top != null) {
        top.scrollIntoView()
        top = null
      }
      const title = this.exportPDFtitle
      // const lableListID = document.querySelectorAll('.result-one_main')
      // if (lableListID[5]) {
      //   lableListID[5].style.marginBottom = '40px'
      // }
      const ST = document.documentElement.scrollTop || document.body.scrollTop
      const SL = document.documentElement.scrollLeft || document.body.scrollLeft
      document.documentElement.scrollTop = 0
      document.documentElement.scrollLeft = 0
      document.body.scrollTop = 0
      document.body.scrollLeft = 0
      const A4_WIDTH = 592.28
      const A4_HEIGHT = 841.89 + 179
      const imageWrapper = document.querySelector('#print') // 获取DOM
      const pageHeight = 841.89 + 179
      const lableListID = imageWrapper.querySelectorAll('.main1')
      for (let i = 0; i < lableListID.length; i++) {
        const o = i + 1
        const multiple = Math.ceil((lableListID[i].offsetTop) / A4_HEIGHT)
        console.log(lableListID[i].offsetTop + lableListID[i].offsetHeight, Math.ceil((lableListID[i]
          .offsetTop + lableListID[i].offsetHeight) / A4_HEIGHT))
        const add = lableListID[i].offsetTop + lableListID[i].offsetHeight < Math.ceil((lableListID[i].offsetTop +
            lableListID[i].offsetHeight) / A4_HEIGHT) &&
          lableListID[o].offsetTop + lableListID[o].offsetHeight > Math.ceil((lableListID[i].offsetTop +
              lableListID[i].offsetHeight) /
            A4_HEIGHT)
        if (add) {
          console.log(lableListID[i], multiple)
          const divParent = lableListID[i].parentNode // 获取该div的父节点
          const newNode = document.createElement('div')
          newNode.className = 'emptyDiv'
          newNode.style.background = '#ffffff'
          const _H = multiple * pageHeight - (lableListID[i].offsetTop + lableListID[i].offsetHeight)
          // 留白
          newNode.style.height = 100 + 'px'
          newNode.style.width = '100%'
          const next = lableListID[i].nextSibling // 获取div的下一个兄弟节点
          console.log(lableListID[i])
          // lableListID[i].style.paddingTop = 120 + 'px'
          // // 判断兄弟节点是否存在
          divParent.style.marginTop = 40 + 'px'
          console.log(divParent)
        }
      }

      html2Canvas(document.querySelector('#print'), {
        allowTaint: true
      }).then(function(canvas) {
        // 获取canvas画布的宽高
        const contentWidth = canvas.width
        const contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度;
        const pageHeight = contentWidth / 841.89 * 592.28
        // 未生成pdf的html页面高度
        let leftHeight = contentHeight
        // 页面偏移
        let position = 0
        // html页面生成的canvas在pdf中图片的宽高（本例为：横向a4纸[841.89,592.28]，纵向需调换尺寸）
        const imgWidth = 841.89
        const imgHeight = 841.89 / contentWidth * contentHeight
        const pageData = canvas.toDataURL('image/jpeg', 1.0)
        const PDF = new JsPDF('l', 'pt', 'a4')
        // 两个高度需要区分: 一个是html页面的实际高度，和生成pdf的页面高度
        // 当内容未超过pdf一页显示的范围，无需分页
        for (let i = 0; i < lableListID.length; i++) {

          // const multiple = Math.ceil((lableListID[i].offsetTop + lableListID[i].offsetHeight) / pageHeight)
          // if (this.isSplit(lableListID, i, multiple * pageHeight)) {
          //   const divParent = lableListID[i].parentNode // 获取该div的父节点
          //   const newNode = document.createElement('div')
          //   newNode.className = 'emptyDiv'
          //   newNode.style.background = '#ffffff'
          //   const _H = multiple * pageHeight - (lableListID[i].offsetTop + lableListID[i].offsetHeight)
          //   // 留白
          //   newNode.style.height = _H + 30 + 'px'
          //   newNode.style.width = '100%'
          //   const next = lableListID[i].nextSibling // 获取div的下一个兄弟节点
          //   // 判断兄弟节点是否存在
          //   if (next) {
          //     // 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
          //     divParent.insertBefore(newNode, next)
          //   } else {
          //     // 不存在则直接添加到最后,appendChild默认添加到divParent的最后
          //     divParent.appendChild(newNode)
          //   }
          // }
        }
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 592.28
            // 避免添加空白页
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      })
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/pdf.js
// module id = null
// module chunks = 